module.exports = __webpack_public_path__ + "img/male_introduction_2.2b7f50ef.png";